import type {
    NavigationGuard,
    RouteLocationRaw,
    RouteRecordRaw,
} from "vue-router"
import { useAuthStore } from "@core/stores/auth.store"
import { ensureAuthUserLoaded } from "@core/router/building.routes"
import PageBuildingPVConsommation from "./pages/PageBuildingPVConsommation.vue"
import PageBuildingPVDimensionnement from "./pages/PageBuildingPVDimensionnement.vue"
import PageBuildingPVEtudeEconomique from "./pages/PageBuildingPVEtudeEconomique.vue"
import PageBuildingPVHistorique from "./pages/PageBuildingPVHistorique.vue"
import PageBuildingPVWrapper from "./pages/PageBuildingPVWrapper.vue"

const beforeEnterBuildingPv: NavigationGuard = async (to, _from, next) => {
    const authStore = useAuthStore()
    await ensureAuthUserLoaded(authStore)
    if (authStore.hasOfferPV) {
        next()
    } else {
        next({
            name: "PageBuildingMeter",
            params: { _id_building: String(to.params._id_building) },
        })
    }
}

export const buildingShellChildren = [
    {
        path: "pv",
        name: "PageBuildingPVWrapper",
        component: PageBuildingPVWrapper,
        beforeEnter: beforeEnterBuildingPv,
        children: [
            {
                path: "",
                redirect: (to): RouteLocationRaw => ({
                    name: "PageBuildingPVConsommation",
                    params: to.params,
                    query: to.query,
                    hash: to.hash,
                }),
            },
            {
                path: "consommation-pv",
                name: "PageBuildingPVConsommation",
                component: PageBuildingPVConsommation,
            },
            {
                path: "etude-economique-pv",
                name: "PageBuildingPVEtudeEconomique",
                component: PageBuildingPVEtudeEconomique,
            },
            {
                path: "etude-pv",
                name: "PageBuildingPVDimensionnement",
                component: PageBuildingPVDimensionnement,
            },
            {
                path: "history-pv",
                name: "PageBuildingPVHistorique",
                component: PageBuildingPVHistorique,
            },
        ],
    },
] as RouteRecordRaw[]
